import axios from 'axios';

export const loadAdtFilterOptions = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-filter-options`, {
			cache: {
				maxAge: 15 * 60 * 1000,
			},
		})
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));

export const loadAdtProviderFilterOptions = (providerId, filter_options) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-provider-filter-options`, {
			cache: {
				maxAge: 15 * 60 * 1000,
			},
			params: {
				filter_options
			}
		})
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));

export const loadExtendedFilterOptions = (providerId) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/get-adt-extended-filter-options`, {
			cache: {
				maxAge: 15 * 60 * 1000,
			},
		})
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	}));
